import * as React from 'react'
import Select from 'react-select'

const durationOptions = [
  { label: '1 Day', value: '1' },
  { label: '3 Days', value: '3' },
  { label: '5 Days', value: '5' },
  { label: '7 Days', value: '7' },
  { label: '10 Days', value: '10' },
  { label: '30 Days', value: '30' },
  { label: '60 Days', value: '60' },
  { label: '90 Days', value: '90' },
  { label: '120 Days', value: '120' }
]

const ListingDurationSelect = props => {
  let finalOptions = durationOptions
  if (props.additionalOptions) finalOptions = finalOptions.concat(props.additionalOptions)
  return <Select {...props} options={finalOptions} simpleValue />
}

export default React.memo(ListingDurationSelect)
